import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { State } from 'src/app/shared/models/State';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { state } from '@angular/animations';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-church-list',
  templateUrl: './church-list.component.html',
  styleUrls: ['./church-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ChurchListComponent implements OnInit {

  dataParent: any;
  //currentUser: any;
  profileUser: any;
  //security: SecurityDocument;
  lstChurches: any[];
  selectedChurch: any;

  countries: any[];
  selectedCountry: any;

  listState: State[];
  selectedState: State = null;

  listCities: any[];
  selectedCity: any = null;
  blocked: boolean = false;

  //Elementos de traducción inicio.
  lstRespTranslate: TranslateRelLabelVO[];
  translations: Record<string, string> = {};

  token: string;
  currentUser: any;
  security: SecurityDocument;




  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private translationService: TovpilLanguageService,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService) {

  }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  openNewChurch() {

    this.openChurchDetail(null);
  }

  openChurchDetail(church: any) {
    let obj = {
      church: church,
      security: this.security,
      countries: this.countries,
      states: this.listState,
      profileUser: this.profileUser,
      selectedCountry: this.selectedCountry != null ? this.selectedCountry : null,
      selectedState: this.selectedState != null ? this.selectedState : null,
      selectedCity: this.selectedCity != null ? this.selectedCity : null
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['/catalogs/churchDetail'], navigationExtras);
  }

  goBack() {
    window.close();
  }

  getSecurity() {

    this.apiService.findSecurityById({
      "id": this.token != null ? this.token : this.currentUser.tokenProfile
    }).then(data => {
      this.security = data;
      this.getGuideProfileServices();
      this.getTranslatedLabels();
    });


    /*this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;
        this.getGuideProfileServices();

        this.getTranslatedLabels();
      });*/
  }

  getListChurchesListServices(countryId: string, stateId: string, filter: string) {
    if (countryId && stateId && filter) {
      this.blocked = true;
      const body = { country: countryId, state: stateId, userId: this.security.userId, filter: filter }
      this.apiService.findChurchsByCountryStateUser(body).then(
        data => {
          this.lstChurches = data;
          this.blocked = false;

        }).catch(error => {
          this.blocked = false;
          console.error(error);
        });
    }
  }

  getGuideProfileServices() {
    console.log("Aqui se solicita servicios");
    console.log("Security:",this.security );
    console.log("CurrentUser:",this.currentUser );


    if (this.security && this.security.guideId) {

      let guideId = this.token != null ? this.token : this.currentUser.tokenProfile
      this.apiService.getGuideProfile({ guideId: this.security.guideId }).then(
        data => {
          this.profileUser = data;
          this.getCountriesServices();
        }).catch(error => {
          this.messageService.add({ key: "tst", severity: 'error', summary: 'ocurrio un error: ' + error + "/", detail: " ", life: 3000 });
        });
    } else {
      this.getCountriesServices();
    }
  }



  exportExcel() {
    if (this.lstChurches === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstChurches.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstChurches.map((item) => {
        return {
          "NOMBRE": item.chr ? (item.chr.name || 'S/N') : 'S/N',
          "CALLE": item.ab ? (item.ab.street || 'S/N') : 'S/N',
          "COLONIA": item.ab ? (item.ab.neight || 'S/N') : 'S/N',
          "CODIGO_POSTAL": item.ab ? (item.ab.zipCode || 'S/N') : 'S/N',
          "CIUDAD": item.ab ? (item.ab.city || 'S/N') : 'S/N',
        };
      });

      this.filesService.tovpilExportXLSX(filteredJSON, 'listChurchs_');

    }
  }



  exportPdf() {
    if (this.lstChurches === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstChurches.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.lstChurches.map((item) => {
        return {
          "NOMBRE": item.chr ? (item.chr.name || 'S/N') : 'S/N',
          "CALLE": item.ab ? (item.ab.street || 'S/N') : 'S/N',
          "COLONIA": item.ab ? (item.ab.neight || 'S/N') : 'S/N',
          "CODIGO_POSTAL": item.ab ? (item.ab.zipCode || 'S/N') : 'S/N',
          "CIUDAD": item.ab ? (item.ab.city || 'S/N') : 'S/N',
        };
      });

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listChurchs_');

    }
  }


  getCountriesServices() {
    this.apiService.getCoutriesFromStore(
      {
        "storeId": this.security.storeId,
        "language": this.security.language
      }
    ).then(countries => {
      this.countries = countries;

      if (!this.selectedCountry && this.profileUser) {
        this.selectedCountry = this.countries.find(s => s.countryId === this.security.region);
      }
      if (!this.selectedCountry) {
        this.selectedCountry = this.countries[0];
      }

      this.getStatesServices(this.selectedCountry.countryId);
    });
  }

  getStatesServices(country: string) {
    this.apiService.getStatesByCountry(country).then(
      data => {
        this.listState = data;
        if (data) {
          if (!this.selectedState && this.profileUser) {
            this.selectedState = this.listState.find(s => s.id.stateId === this.profileUser.address.state);
          }

          if (!this.selectedState) {
            this.selectedState = this.listState[0];
          }
          if (this.selectedState) {
            this.getCitiesFromStateServices(this.selectedState.id.stateId);
          }
        }
      }).catch(error => {
        console.error(error);
      });;
  }


  getCitiesFromStateServices(state: string) {

    let body = {
      country: this.selectedCountry.countryId,
      state: state,
      reportType: "CHURCHS"
    }

    this.apiService.getCitiesFromState(body).then(

      data => {
        this.listCities = data;
        if (data) {

          if (!this.selectedCity && this.profileUser && this.selectedState.id.stateId === this.profileUser.address.state) {
            this.selectedCity = this.listCities.find(s => s.valueId === this.profileUser.address.city);
          }
          if (!this.selectedCity) {
            this.selectedCity = this.listCities[0];
          }

          if (this.selectedCity) {
            this.getListChurchesListServices(this.selectedCountry.countryId, this.selectedState.id.stateId, this.selectedCity.value);
          }
        }
      }).catch(error => {
        console.error(error);
      });

  }

  search() {

  }
  onChangeCountry() {
    this.lstChurches = [];
    this.listCities = [];
    this.selectedCity = null;
    this.selectedState = null;
    this.getStatesServices(this.selectedCountry.countryId);

  }
  onChangeState() {
    this.lstChurches = [];
    this.listCities = [];
    this.selectedCity = null;
    this.getCitiesFromStateServices(this.selectedState.id.stateId);

  }

  onChangeCity() {
    this.lstChurches = [];
    if (this.selectedCity) {
      this.getListChurchesListServices(this.selectedCountry.countryId, this.selectedState.id.stateId, this.selectedCity.value);
    }

  }

  deleteChurch(church: any) {
    this.confirmationService.confirm({
      message: '¿ '+this.translations.lbl_are_you_sure +' '+ this.translations.lbl_delete_record +' '+ this.translations.lbl_church_name+ ' ?',
      header: this.translations.lbl_confirm +' '+ this.translations.lbl_delete_record,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteChurchServices(church);
      }
    });
  }

  deleteChurchServices(church: any) {

    const body = {
      guideId: this.security.guideId,
      language: this.security.language,
      method: "DELETE",
      church: church.chr,
      address: church.ab

    }
    this.apiService.crudChurch(body).then(
      data => {

        if (data && data.status == 'OK') {

          this.messageService.add({ key: "tst", severity: 'success', summary: 'Eliminar Parroquia', detail: "Se elimino parroquia correctamente", life: 5000 });
          this.getListChurchesListServices(this.selectedCountry.countryId, this.selectedState.id.stateId, this.selectedCity.value);
        } else {
          this.messageService.add({ key: "tst", severity: 'error', summary: 'Eliminar Parroquia: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ key: "tst", severity: 'error', summary: 'Eliminar Parroquia' + error + "/", detail: "Error al eliminar Parroquia" + error + "/", life: 3000 });
      });
  }
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}`});
      // Error al traer labels traducidos
    }
  }

  checEnableButtons(chr: any) {

    if (this.security.levelId == 'L' || this.security.levelId == 'N' || this.security.levelId == 'Z' || this.security.levelId == 'I' || this.security.userId == chr.chr.userId) {
      return false;
    } else {
      return true;
    }
  }
}
